import { render, staticRenderFns } from "./PrivacyPolicyNL.vue?vue&type=template&id=d6382ae4&scoped=true"
import script from "./PrivacyPolicyNL.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyNL.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyNL.vue?vue&type=style&index=0&id=d6382ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6382ae4",
  null
  
)

export default component.exports